<template>
  <div id="wrapper navbar-mini">
    <slot name="side-menu"></slot>
    <div id="page-wrapper" class="gray-bg">
      <slot name="header"></slot>
      <can :action="action" :subject="subject" :is-page="true" v-if="action && subject">
        <router-view></router-view>
      </can>
      <div v-else>
        <router-view></router-view>
      </div>
      <div style="height: 40px"></div>
      <slot name="footer"></slot>
    </div>
    <slot name="toast"></slot>
    <slot name="alerts"></slot>
  </div>
</template>

<script>
import Can from '@/components/permissions/Can';

export default {
  name: 'MainLayout',
  props: ['action', 'subject'],

  components: {
    Can,
  },
};
</script>



// WEBPACK FOOTER //
// MainLayout.vue?0ef26780